const customerDialogTemplate = [
    {
        title: 'General',
        fields: [
            {
                label: 'Name',
                component: 'VTextField',
                model: 'name',
                required: true,
                rules: 'required'
            },
            {
                label: 'Last Name',
                component: 'VTextField',
                model: 'lastname'
            },
            {
                label: 'ID Document',
                component: 'VTextField',
                model: 'docid',
                required: true
            },
            {
                label: 'Email',
                component: 'VTextField',
                model: 'email',
                rules: 'email',
                required: true
            },
            {
                label: 'Phone No.',
                component: 'VTextField',
                model: 'phone',
                required: true
            },
            {
                label: 'Mobile Phone No.',
                component: 'VTextField',
                model: 'mobile'
            },
            {
                label: 'Agency',
                component: 'AgencyFilter',
                model: 'agency',
                returnObject: true,
                required: true,
                rules: 'required'
            },
            {
                label: 'Agent',
                component: 'AgentFilter',
                model: 'agent',
                returnObject: true
            },
            {
                label: 'Group Tariff',
                component: 'GroupTariffFilter',
                model: 'groupTariff',
                returnObject: true
            },
            {
                label: 'Location',
                component: 'LocationFilter',
                model: 'location',
                returnObject: true
            },
            {
                label: 'Company',
                component: 'VSwitch',
                initialValue: false,
                model: 'customerType'
            }
        ]
    },
    {
        title: 'Emails',
        fields: [
            {
                label: 'Emails',
                component: 'EmailTagField',
                initialValue: false,
                model: 'emailAddresses',
                oneColumn: true
            }
        ]
    },
    {
        title: 'Address',
        fields: [
            {
                label: 'Address',
                component: 'VTextField',
                model: 'address',
                required: true
            },
            {
                label: 'City',
                component: 'City',
                model: 'city',
                returnObject: true,
                required: true
            },
            {
                label: 'State',
                disabled: true,
                component: 'VTextField',
                model: 'state'
            },
            {
                label: 'Zip Code',
                component: 'VTextField',
                model: 'zip',
                required: true
            },
            {
                label: 'Country',
                disabled: true,
                component: 'VTextField',
                model: 'country'
            }
        ]
    }
];

const addressListTemplate = {
    title: 'Addresses',
    type: 'rows',
    actions: [
        {
            title: 'New Address',
            name: 'new',
            icon: 'mdi-plus'
        }
    ],
    fields: [
        {
            label: 'Name',
            component: 'VTextField',
            model: 'fullName',
            width: '200',
            visible: true
        },
        {
            label: 'Address',
            component: 'VTextField',
            model: 'formattedAddress',
            width: '300',
            visible: true
        },
        {
            label: 'Phone',
            component: 'VTextField',
            model: 'phone',
            width: '150',
            visible: true
        },
        {
            label: 'Email',
            component: 'VTextField',
            model: 'email',
            width: '200',
            visible: true
        },
        {
            label: 'Default',
            component: 'VSwitch',
            model: 'isDefault',
            width: '100',
            visible: true,
            align: 'center'
        }
    ]
};

export { customerDialogTemplate, addressListTemplate };
